import { apiV2 } from './api';

export const getPhysicians = (clinicId) => apiV2.get(`/clinics/clinic/physicians-by-clinic/${clinicId}`);

export const calculateSummary = (subscriptionId, payload) => apiV2.post(`/subscriptions/subscription/${subscriptionId}/new-subscription-summary/?trial=true`, payload);
